import React, { useState } from "react";
import { Modal } from '@themesberg/react-bootstrap';
import { Button, Form, Input, Select, Upload } from "antd";
import { InboxOutlined } from '@ant-design/icons'
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { createAboutModal, aboutRefresh, editAboutModal, editABoutVal } from "../../../states/about";
import { settingAlert, settingResponse } from "../../../states/settings";
import { dummyRequest } from "../../../services/utilities";
import { createCareer, createCareerOthers, updateAbout, updateCareer } from "../../../services/apiCalls";
import { careerRefresh, editCareerModal, editCareerVal } from "../../../states/career";

const AboutModal = () => {
  const [loading, setLoading] = useState(false)
  const setShowAlert = useSetRecoilState(settingAlert);
  const setResponse = useSetRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(careerRefresh)
  const [showModal, setShowModal] = useRecoilState(createAboutModal);
  const [uploadImage, setUploadImage] = useState(false)
  const [minds, setMind] = useState(false)
  const [file, setFile] = useState({})
  const [form] = Form.useForm()

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const handleSubmit = async (val) => {
    const date = new Date()
    setLoading(true)
    const fd = new FormData();
    fd.append('title', val.title)
    fd.append('content', val.content)
    fd.append('type', val.type)
    fd.append('file', file);
    const res = await createCareerOthers(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setShowModal(false)
      setFile("")
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  const onChange = (v) => {
    console.log(v)
    if (v === "other" || v === "benefit") { 
      setUploadImage(false)
    } else { 
      setUploadImage(true) 
    }
    if (v === "mind") { 
      setMind(false)
    } else { 
      setMind(true) 
    }
  }
  return (
    <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header>
        <Modal.Title className="h6">Create New Feature</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)} />
      </Modal.Header>
      <Modal.Body>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>          
          <Form.Item label="Type" name="type" rules={[{ required: true }]}>
            <Select onChange={onChange}>
              <Select.Option key='1' value="mind">Vibrant, Brilliant Minds</Select.Option>
              <Select.Option key='2' value="benefit">Benefits and Perks</Select.Option>
              <Select.Option key='3' value="other">Other</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          {/* {minds &&  */}
            <Form.Item label="Description" name="content" rules={[{ required: true }]}>
              <Input.TextArea />
            </Form.Item>
          {/* }
          {uploadImage &&  */}
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <Button icon={<InboxOutlined />}>Upload Image</Button>
              </Upload>
            </Form.Item>
          {/* } */}
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Create
            </Button>
          </Form.Item>
        </Form>
      </Modal.Body>
    </Modal>
  )
}
export default AboutModal

export const EditModal = () => {
  const [loading, setLoading] = useState(false)
  const setShowAlert = useSetRecoilState(settingAlert);
  const setResponse = useSetRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(careerRefresh)
  const value = useRecoilValue(editCareerVal)
  const [showModal, setShowModal] = useRecoilState(editCareerModal);
  const [file, setFile] = useState({})
  const [form] = Form.useForm()
  form.setFieldsValue({ title: value.title, content: value.content, id: value.id, image_url: value.image_url })

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const handleSubmit = async (val) => {
    const date = new Date()
    setLoading(true)
    const fd = new FormData();
    fd.append('title', val.title)
    fd.append('content', val.content)
    fd.append('file', file);
    fd.append('id', val.id);
    // fd.append('image_url', val.image);
    const res = await updateCareer({ data: fd, id: val.id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setShowModal(false)
      setFile("")
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  return (
    <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header>
        <Modal.Title className="h6">Update Feature</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)} />
      </Modal.Header>
      <Modal.Body>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item hidden name="id">
            <Input />
          </Form.Item>
          {/* <Form.Item name="image_url">
            <Input />
          </Form.Item> */}
          {value.type === 'benefit' &&
            <Form.Item label="Description" name="content" >
              <Input.TextArea />
            </Form.Item>
          }          
          {value.type === 'mind' &&
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <Button icon={<InboxOutlined />}>Upload Image</Button>
              </Upload>
            </Form.Item>
          }
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal.Body>
    </Modal>
  )
}